module.exports = __webpack_public_path__ + "static/media/background-remover.4678d781.png";